import { OrderDetails, TransactionType } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../../shared/components/Text';
import { OrderAction } from '../../../../../types/OrderAction';
import { OrderActionType } from '../../../../../types/OrderActionType';
import { OrderLineInAction } from '../../../../../types/OrderLineInAction';
import { PayoutStatus } from '../../../../../types/PayoutStatus';
import { getInfoAndTooltip } from './getInfoAndTooltip';

export const getPayoutActions = (orderDetails: OrderDetails, actions: OrderAction[]): OrderAction[] => {
  const currency = orderDetails.currency;
  const payoutActions: OrderAction[] = [];
  let index = 1;

  if (orderDetails.transactions)
    if (orderDetails.transactions.length > 0) {
      orderDetails.transactions
        .sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1))
        .forEach((transaction) => {
          const currentPayoutIndex = payoutActions.findIndex((el) => el.id === transaction.payoutId);
          const negativeAmountTransactionTypes = [
            TransactionType.FIXED_FEE,
            TransactionType.VARIABLE_FEE,
            TransactionType.COST_OF_CREDIT,
          ];
          const transactionAmount = negativeAmountTransactionTypes.includes(transaction.type)
            ? -transaction.amount
            : transaction.amount;

          const { info, tooltip } = getInfoAndTooltip(transaction, orderDetails, actions);
          const transactionOrderLine: OrderLineInAction = {
            id: transaction.id,
            name: Text({ tId: transaction.type }),
            amount: { value: transactionAmount, currency },
            infoText: info,
            tooltip: tooltip,
          };

          const payoutDoesNotExistYet = currentPayoutIndex === -1;
          if (payoutDoesNotExistYet) {
            payoutActions.push({
              id: transaction.payoutId,
              type: OrderActionType.payout,
              status: PayoutStatus.PAID,
              createdAt: transaction.payoutDate,
              updatedAt: transaction.updatedAt,
              number: index,
              amount: { value: transactionAmount, currency },
              orderLines: [transactionOrderLine],
            });
            index++;
          } else {
            const targetPayoutAction = payoutActions[currentPayoutIndex];
            targetPayoutAction.amount.value = targetPayoutAction.amount.value + transactionAmount;
            targetPayoutAction.orderLines.push(transactionOrderLine);
          }
        });
    }
  return payoutActions;
};
